export type SiteInfo = {
  site: string;
  isBridgeSite: boolean;
  defaultLang: string;
  pathPrefix: string;
};

const FALLBACK: SiteInfo = {
  site: "",
  isBridgeSite: false,
  defaultLang: "en",
  pathPrefix: "",
};

const SAFE_PREFIXES = new Set(["", "/casino"]);

const getSiteInfo = (): SiteInfo => {
  if (typeof document === "undefined") return FALLBACK;
  const raw = document.cookie
    .split("; ")
    .find((row) => row.startsWith("siteInfo="))
    ?.split("=")[1];
  return parseSiteInfo(raw);
};

export const parseSiteInfo = (raw?: string): SiteInfo => {
  if (!raw) return FALLBACK;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (!parsed || typeof parsed !== "object") return FALLBACK;
    const obj: SiteInfo = {
      site: parsed.site ?? "",
      isBridgeSite: parsed.isBridgeSite ?? false,
      defaultLang: parsed.defaultLang ?? "en",
      pathPrefix: SAFE_PREFIXES.has(parsed.pathPrefix) ? parsed.pathPrefix : "",
    };
    return { ...FALLBACK, ...obj };
  } catch {
    return FALLBACK;
  }
};

export default getSiteInfo;
